<template>
  <section>
    <!-- 统计文字 -->
    <!--<el-row class="total">
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-question sicon c1"></i>
        <span class="tjContent">
          <div>访问人数</div>
          <div class="numText t1">{{cdata.total.visit_uv||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-success sicon c2"></i>
        <span class="tjContent">
          <div>新增访问</div>
          <div class="numText t2">{{cdata.total.visit_uv_new||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-news sicon c3"></i>
        <span class="tjContent">
          <div>打开次数</div>
          <div class="numText t3">{{cdata.total.session_cnt||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-tickets sicon c2"></i>
        <span class="tjContent">
          <div>新增授权</div>
          <div class="numText t2">{{cdata.total.auth_uv_new||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-tickets sicon c4"></i>
        <span class="tjContent">
          <div>单用户点击数</div>
          <div class="numText t4">{{cdata.total.click_per||'0'}}</div>
        </span>
      </el-card>
    </el-row>-->
    <el-row class="statusRowWhite" style="min-width:1200px;padding:15px;background:#fff">
      		<div class="RowChild">
      		&nbsp;日期： &nbsp;
	          <!--<el-button size="medium" type="primary" @click="goback" icon="el-icon-back">返回</el-button>-->
	          <el-button type="primary" plain @click="changeDate(1)" id="yesterday">昨天</el-button>
	          <el-button type="primary" plain @click="changeDate(2)"  >前天</el-button>
	          <!--<el-button type="primary" plain @click="changeDate(7)" id='seven'>最近7天</el-button>-->
	          <el-date-picker v-model="pdata.sdate" type="date" placeholder="选择日期时间" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" align="right" @change="selectDate" ></el-date-picker>
          </div>
          <div class="RowChild">
	      		&nbsp;选择小程序： &nbsp;
		         <el-select v-model="chooseProduct.name" filterable  placeholder="请输入/选择小程序名称">
		            <el-option
		              v-for="item in IssAppList"
		              :key="item.id"
		              :label="item.name"
		              :value="item.id"
		              @click.native="changeProduct(item)"
		              default-first-option>
		            </el-option>
	          </el-select>
	        </div>
	        <div class="RowChild">
	      		&nbsp;选择渠道： &nbsp;
	          <el-select v-model="chooseChannel.name" filterable clearable  placeholder="请输入/选择渠道"   @clear="clearChannel">
	            <el-option
	              v-for="item in IssuedAldChanneList"
	              :key="item.id"
	              :label="item.ald_channel"
	               @click.native="changeChannel(item)"
	              :value="item.id">
	            </el-option>
	          </el-select>
	        </div>  
	        <div class="RowChild">
	      		&nbsp;选择公司： &nbsp;
	          <el-select  v-model="pdata.company_id"  clearable filterable placeholder="请选择对应公司">
	              <el-option v-for="item in companys" :key="item.company_id" :label="item.company_name" :value="item.company_id"></el-option>
	          </el-select>
	         </div>
	         
          <!--<el-input @clear="getList" @keyup.enter.native="getList" ref="input" class="search xs24" v-model="pdata.company" clearable placeholder="请输入公司名称" :suffix-icon="pdata.company.length>0?'':'el-icon-search'"></el-input>-->
          <!--<el-input style="width:170px" @clear="getList" @keyup.enter.native="getList" ref="input" class="search" v-model="pdata.kw" clearable placeholder="请输入渠道名称" :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"></el-input>-->
					<div class="RowChild">
	      		&nbsp;选择状态： &nbsp;
	          <!--新增筛选状态条件-->
	          <el-select v-model="pdata.status" filterable  placeholder="请选择状态" @change="statusChange">
	            <el-option label="全部" value=""></el-option>
	            <el-option label="正常" value="1"></el-option>
	            <el-option label="已通知下线" value="0"></el-option>
	            <el-option label="已确认下线" value="2"></el-option>
	          </el-select>
					 </div>
					 <div class="RowChild">
	      		&nbsp;用户操作： &nbsp;
	         <!-- <el-button type="warning" @click="editAldChannelDiscount(multipleSelection,2)">批量扣量</el-button>-->
	          
	          <el-button type="primary" @click="fieldConfig">字段选择</el-button>
	          <el-button type="primary" @click="showBatchDialog(1)">批量通知下线</el-button>
	          <el-button type="primary" @click="showBatchDialog(2)">批量截止下线</el-button>
	          <el-button type="text" @click="downloadTemp(1)">批量通知下线模板</el-button>
	          <el-button type="text" @click="downloadTemp(2)">批量截止下线模板</el-button>
           </div>
          <!--<el-button type="primary" @click="batchAddProduct">导入</el-button>
          <el-button size="medium" type="text" @click="downloadTemp">导入模板下载</el-button>-->

   
      <!--<el-col :span="10">
        <div style="float:right;min-width:150px">
         
        </div>
      </el-col>-->
    </el-row>
		
		           
		<el-row  class="totalBox">
			<el-col :span="2" class="lh45 tc h45">单日总计</el-col>
			<el-col :span="2" class="lh45 tc h45">新增UV</el-col>
			<el-col :span="2" class="lh45 tc h45">UV</el-col>
			<el-col :span="2" class="lh45 tc h45">产品总支出</el-col>
			<el-col :span="2" class="lh45 tc h45">新增占比</el-col>
			<el-col :span="2" class="lh45 tc h45">渠道活跃占比</el-col>
			<el-col :span="2" class="lh45 tc h45">点击单价</el-col>
			<el-col :span="2" class="lh45 tc h45">分发arpu</el-col>
			<el-col :span="2" class="lh45 tc h45">分成后原生arpu</el-col>
			<el-col :span="2" class="lh45 tc h45">总 arpu</el-col>
			<el-col :span="2" class="lh45 tc h45">活跃单日回收</el-col>
			<el-col :span="2" class="lh45 tc h45">最高承受单价</el-col>
			
		</el-row>
		<el-row  class="totalBox">
			<el-col :span="2" class="lh45 tc h45">{{chooseProduct.name}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.visit_uv_new||0}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.visit_uv||0}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.cost}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.new_per}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.uv_per}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.click_price}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.arpu_ff}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.arpu_fc}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.arpu}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.uv_back_0}}</el-col>
			<el-col :span="2" class="lh45 tc h45">{{cdata.total.hold_price}}</el-col>

		</el-row>
    
    <!-- 图表 -->
    <!--<el-row style="min-width:1200px;background:#fff">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>-->
    <!--列表-->
    <el-table :data="cdata.list" style="width: 100%;min-width:1200px" stripe row-key="id" :row-class-name="tableRowClassName" @selection-change="handleSelection">
       <el-table-column type="selection" :selectable='selectionDisabled'></el-table-column>
      
      <!--<el-table-column prop="app_name" label="发行游戏" show-overflow-tooltip min-width="100" align="left">
      	<template slot-scope="scope">
	          <span>{{scope.row.app_name}}</span>
	      </template>
      </el-table-column>-->
      <el-table-column prop="ald_channel" label="渠道" show-overflow-tooltip min-width="100" align="left">
        <!--<template slot-scope="scope" ><span class="blue" @click="editAldChannelDiscount(scope.row)">{{scope.row.ald_channel}}</span></template>-->
      </el-table-column>
      <el-table-column prop="company" label="公司名称" show-overflow-tooltip min-width="90" align="left"> </el-table-column>
     
     <el-table-column :prop="item.key" :label="item.name" align="center" v-for="item in showFieldList"  sortable :sort-method="(a,b)=>{return parseFloat(a[item.key]) - parseFloat(b[item.key])}">
	
				<template slot-scope="scope">

					
	
					<span class="orange" @click="editAtv(scope.row)" v-if="item.key=='atv'">{{scope.row[item.key]}}</span>


					<span  v-else-if="item.key=='jump_per'">
						<span v-if="scope.row[item.key]!=null">{{scope.row[item.key]||0}}%</span><span v-else>--</span>
					</span>
					
					
					<span v-else>{{scope.row[item.key]}}</span>
				</template>
				
			</el-table-column>
<!--      <el-table-column prop="visit_uv_new" label="新增UV" align="left"> </el-table-column>-->
      <!--<el-table-column
        prop="visit_uv_new"
        label="新增UV" min-width="94"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.visit_uv_new-0)-(b.visit_uv_new-0)}"
      ></el-table-column>
   
      <el-table-column
        prop="visit_uv"
        label="UV" min-width="94"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.visit_uv-0)-(b.visit_uv-0)}"
      ></el-table-column>
      -->
      <!--<el-table-column prop="type" label="采集来源" show-overflow-tooltip min-width="94" align="left">
      		<template slot-scope="scope" ><span class="blue" @click="editAtv(scope.row)">{{scope.row.type}}</span></template>
      </el-table-column>-->
      <!--<el-table-column prop="atv"  sortable min-width="100"  :sort-method="(a,b)=>{return (a.atv-0)-(b.atv-0)}" label="获客单价" align="left">
  			<template slot-scope="scope" ><span :class="scope.row.buy_source==1?'blue':'orange'" @click="editAtv(scope.row)">{{scope.row.atv}}</span></template>
      </el-table-column>
      
      <el-table-column prop="new_per" min-width="130" label="买量新增占比" sortable :sort-method="(a,b)=>{return (a.new_per-0)-(b.new_per-0)}">
      	 <template slot-scope="scope"><span >{{scope.row.new_per}}%</span></template>
      </el-table-column>-->
      <!--<el-table-column prop="cost" label="买量成本" align="left"> </el-table-column>
      -->
     
      
      <!--<el-table-column prop="jump_per" min-width="90" label="新增跳出率" align="left"
        sortable
        :sort-method="(a,b)=>{return (a.jump_per-0)-(b.jump_per-0)}">
      		<template slot-scope="scope"><span v-if="scope.row.jump_per!=null">{{scope.row.jump_per||0}}%</span><span v-else>--</span> </template>
      </el-table-column>
      
      <el-table-column prop="back_0" label="新增当天回收" show-overflow-tooltip min-width="100" align="left" sortable :sort-method="(a,b)=>{return parseFloat(a.back_0=='-'?0:a.back_0) - parseFloat(b.back_0=='-'?0:b.back_0)}">
      	<template slot-scope="scope"><span v-if="scope.row.back_0!=null">{{scope.row.back_0||0}}%</span><span v-else>--</span> </template>
      </el-table-column>-->
      
     <!-- <el-table-column prop="back_1" label="新增次日回收" show-overflow-tooltip min-width="100" align="left" sortable :sort-method="(a,b)=>{return parseFloat(a.back_1=='-'?0:a.back_1) - parseFloat(b.back_1=='-'?0:b.back_1)}"></el-table-column>-->
     	
     	 <!--<el-table-column prop="uv_jump_per" min-width="90" label="活跃跳出率" align="left"
        sortable
        :sort-method="(a,b)=>{return (a.uv_jump_per-0)-(b.uv_jump_per-0)}">
      		<template slot-scope="scope"><span v-if="scope.row.jump_per!=null">{{scope.row.uv_jump_per||0}}%</span><span v-else>--</span> </template>
      </el-table-column>
      <el-table-column prop="uv_back_0" label="活跃当天回收" show-overflow-tooltip min-width="100" align="left" sortable :sort-method="(a,b)=>{return parseFloat(a.uv_back_0=='-'?0:a.uv_back_0) - parseFloat(b.uv_back_0=='-'?0:b.uv_back_0)}">
      	<template slot-scope="scope"><span v-if="scope.row.uv_back_0!=null">{{scope.row.uv_back_0||0}}%</span><span v-else>--</span> </template>
      </el-table-column>
      <el-table-column prop="total_back_0" label="累计当日回收" show-overflow-tooltip min-width="100" align="left" sortable :sort-method="(a,b)=>{return parseFloat(a.total_back_0=='-'?0:a.total_back_0) - parseFloat(b.total_back_0=='-'?0:b.total_back_0)}">
      	<template slot-scope="scope"><span v-if="scope.row.total_back_0!=null">{{scope.row.total_back_0||0}}%</span><span v-else>--</span> </template>
      </el-table-column>-->
      <!--<el-table-column prop="day1" label="1日留存" align="left" min-width="94" sortable :sort-method="(a,b)=>{return (a.day1-0)-(b.day1-0)}">
      	  <template slot-scope="scope"><span v-if="scope.row.day1!=null">{{scope.row.day1||0}}%</span><span v-else>--</span> </template>
      </el-table-column>-->
      <!--<el-table-column prop="day2" label="2日留存" align="left" min-width="94" sortable :sort-method="(a,b)=>{return (a.day2-0)-(b.day2-0)}">
      	<template slot-scope="scope"><span v-if="scope.row.day2!=null">{{scope.row.day2||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day3" label="3日留存" align="left" min-width="94" sortable :sort-method="(a,b)=>{return (a.day3-0)-(b.day3-0)}">
      		<template slot-scope="scope"><span v-if="scope.row.day3!=null">{{scope.row.day3||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day4" label="4日留存" align="left" min-width="94" sortable :sort-method="(a,b)=>{return (a.day4-0)-(b.day4-0)}">
      		<template slot-scope="scope"><span v-if="scope.row.day4!=null">{{scope.row.day4||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day5" label="5日留存" align="left" min-width="94" sortable :sort-method="(a,b)=>{return (a.day5-0)-(b.day5-0)}">
      		<template slot-scope="scope"><span v-if="scope.row.day5!=null">{{scope.row.day5||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day6" label="6日留存" align="left" min-width="94" sortable :sort-method="(a,b)=>{return (a.day6-0)-(b.day6-0)}">
      		<template slot-scope="scope"><span v-if="scope.row.day6!=null">{{scope.row.day6||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day7" label="7日留存" align="left" min-width="94" sortable :sort-method="(a,b)=>{return (a.day7-0)-(b.day7-0)}">
      		<template slot-scope="scope"><span v-if="scope.row.day7!=null">{{scope.row.day7||0}}%</span><span v-else>--</span> </template>
      </el-table-column>-->
      <!--<el-table-column prop="update_time" label="下线时间" align="left" sortable min-width="140">
      		<template slot-scope="scope"><span v-if="scope.row.update_time!=null && (scope.row.status==0 || scope.row.status==2)">{{scope.row.update_time}}</span><span v-else>--</span> </template>
      </el-table-column>-->
       
      
      <el-table-column prop="" label="操作" align="left" width="330" fixed="right">
	      <template slot-scope="scope">
            <!--<el-button v-if="scope.row.pr!='-'" style="width:90px;" size="mini" type="warning" @click="editAldChannelDiscount(scope.row,1)">扣量：{{scope.row.pr=='-'?'-':parseFloat(scope.row.pr).toFixed(2)}}</el-button>
            <el-button v-else size="mini" style="width:90px;" type="info" class="el-button--mini is-disabled" @click="editAldChannelDiscount(scope.row,1)">扣量</el-button>-->
            <el-button size="mini" type="primary" @click="showDetail(scope.row)">详情</el-button>
            <el-button style="width: 90px;" v-if="scope.row.status==1" size="mini" type="danger" @click="notifyOff(scope.$index,scope.row,0)">通知下线</el-button>
            <el-button style="width: 130px;" v-if="scope.row.status==0||scope.row.status==2" size="mini" type="info" @click="notifyOff(scope.$index,scope.row,1)">已通知 {{scope.row.update_time.split(' ')[0]}}</el-button>
            <el-button style="width: 130px;" v-if="scope.row.status==2" size="mini" type="info" disabled>已截止 {{scope.row.update_time.split(' ')[0]}}</el-button>
            <el-button style="width: 90px;" v-if="scope.row.status==0" size="mini" type="info"  @click="notifyOff(scope.$index,scope.row,2)">截止下线</el-button>
	      </template>
      </el-table-column>


    </el-table>

    <!--<el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>-->
    
    <el-dialog title="详情" :visible.sync="detailDialog" width="95%">
    	 		<el-row :gutter="10">
						选择日期：
	    			<el-date-picker
	            v-model="dateVal2"
	            type="daterange"
	            range-separator="至"
	            start-placeholder="开始日期"
	            end-placeholder="今天"
	            format="yyyy 年 MM 月 dd 日"
	            value-format="yyyy-MM-dd"
	            :picker-options="pickerOptions"
	          ></el-date-picker>
          </el-row>
    	    <el-table :data="ddata.list" style="width: 100%;min-width:1200px" stripe row-key="id">

				     
				      <!--<el-table-column prop="app_name" label="发行游戏" align="left">
				      </el-table-column>-->
				      <el-table-column prop="d_date" label="日期" align="left"> </el-table-column>
				      <el-table-column prop="ald_channel" label="渠道" align="left"> </el-table-column>
				      <el-table-column :prop="item.key" :label="item.name" align="center" v-for="item in showFieldList" v-if="item.key!='update_time'"  sortable :sort-method="(a,b)=>{return parseFloat(a[item.key]) - parseFloat(b[item.key])}">
								<template slot="header" slot-scope="scope">
									<el-tooltip class="item" effect="dark" content="双击数字可修改获客单价" placement="top-start" v-if="item.key=='atv'">
										<span>{{item.name}}<i class="el-icon-question"></i></span>
									</el-tooltip>
									<span v-else>{{item.name}}</span>
								</template>
								<template slot-scope="scope">
				
									<span  v-if="item.key=='jump_per'">
										<span v-if="scope.row[item.key]!=null">{{scope.row[item.key]||0}}%</span><span v-else>--</span>
									</span>
									<span class="orange"  v-else-if="item.key=='atv'">
										<span @dblclick="atvDetailEdit(scope)" v-if="scope.row.isEdit==false">{{scope.row[item.key]}}</span>
										<span  v-else><el-input placeholder="输入获客单价" v-model="chooseDetailAtv.atv" class="w50" size='mini' @change="postAtv('detail')" :autofocus="true"></el-input></span>
										<!--{{scope.row.isEdit}}-->
									</span>
									
									
									
									<span v-else>{{scope.row[item.key]}}</span>
								</template>
								
							</el-table-column>
				      <!--<el-table-column prop="visit_uv_new" label="新增UV" align="left"> </el-table-column>
				      <el-table-column prop="visit_uv" label="UV" align="left"> </el-table-column>
				      <el-table-column prop="visit_uv_new_price" label="新增单价" align="left"> </el-table-column>
				      <el-table-column prop="jump_per" label="新增跳出率" align="left">
				      		<template slot-scope="scope"><span v-if="scope.row.jump_per!=null">{{scope.row.jump_per||0}}%</span><span v-else>--</span> </template>
				      </el-table-column>
				      
				      <el-table-column prop="visit_uv_new_arpu" label="新增arpu" align="left"> </el-table-column>
				      <el-table-column prop="back_0" label="新增当天回收" show-overflow-tooltip min-width="100" align="left" sortable :sort-method="(a,b)=>{return parseFloat(a.back_0) - parseFloat(b.back_0)}">
				      	<template slot-scope="scope"><span v-if="scope.row.back_0!=null">{{scope.row.back_0||0}}%</span><span v-else>--</span> </template>
				      </el-table-column>
      
				      <el-table-column prop="back_1" label="新增次日回收" show-overflow-tooltip min-width="100" align="left" sortable :sort-method="(a,b)=>{return parseFloat(a.back_1) - parseFloat(b.back_1)}">
				      	<template slot-scope="scope"><span v-if="scope.row.back_1!=null">{{scope.row.back_1||0}}%</span><span v-else>--</span> </template>
				      </el-table-column>
				     
				      <el-table-column prop="visit_uv_price" label="活跃单价" align="left"> </el-table-column>
				      <el-table-column prop="uv_jump_per" min-width="90" label="活跃跳出率" align="left"
				        sortable
				        :sort-method="(a,b)=>{return (a.uv_jump_per-0)-(b.uv_jump_per-0)}">
				      		<template slot-scope="scope"><span v-if="scope.row.jump_per!=null">{{scope.row.uv_jump_per||0}}%</span><span v-else>--</span> </template>
				      </el-table-column>
				      <el-table-column prop="visit_uv_arpu" label="活跃arpu" align="left"> </el-table-column>
				      
				       <el-table-column prop="uv_back_0" label="活跃当天回收" show-overflow-tooltip min-width="100" align="left" sortable :sort-method="(a,b)=>{return parseFloat(a.uv_back_0=='-'?0:a.uv_back_0) - parseFloat(b.uv_back_0=='-'?0:b.uv_back_0)}">
				       	<template slot-scope="scope"><span v-if="scope.row.uv_back_0!=null">{{scope.row.uv_back_0||0}}%</span><span v-else>--</span> </template>
				       </el-table-column>
				      
				      
				      <el-table-column prop="total_back_0" label="累计当天回收" align="left"> 
				      	<template slot-scope="scope"><span v-if="scope.row.total_back_0!=null">{{scope.row.total_back_0||0}}%</span><span v-else>--</span> </template>
				      </el-table-column>

				    
				      
     					
				     
				      <el-table-column prop="day1" label="1日留存" align="left">
				      	  <template slot-scope="scope"><span v-if="scope.row.day1!=null">{{scope.row.day1||0}}%</span><span v-else>--</span> </template>
				      </el-table-column>-->
				      <!--<el-table-column prop="day2" label="2日留存" align="left">
				      	<template slot-scope="scope"><span v-if="scope.row.day2!=null">{{scope.row.day2||0}}%</span> <span v-else>--</span></template>
				      </el-table-column>
				      <el-table-column prop="day3" label="3日留存" align="left">
				      		<template slot-scope="scope"><span v-if="scope.row.day3!=null">{{scope.row.day3||0}}%</span> <span v-else>--</span></template>
				      </el-table-column>
				      <el-table-column prop="day4" label="4日留存" align="left">
				      		<template slot-scope="scope"><span v-if="scope.row.day4!=null">{{scope.row.day4||0}}%</span> <span v-else>--</span></template>
				      </el-table-column>
				      <el-table-column prop="day5" label="5日留存" align="left">
				      		<template slot-scope="scope"><span v-if="scope.row.day5!=null">{{scope.row.day5||0}}%</span> <span v-else>--</span></template>
				      </el-table-column>
				      <el-table-column prop="day6" label="6日留存" align="left">
				      		<template slot-scope="scope"><span v-if="scope.row.day6!=null">{{scope.row.day6||0}}%</span> <span v-else>--</span></template>
				      </el-table-column>
				      <el-table-column prop="day7" label="7日留存" align="left">
				      		<template slot-scope="scope"><span v-if="scope.row.day7!=null">{{scope.row.day7||0}}%</span><span v-else>--</span> </template>
				      </el-table-column>-->

				    </el-table>
    </el-dialog>

    <el-dialog title="编辑创意组合" :visible.sync="editDialog">
      <el-form :model="group"></el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editDialog = false">确 定</el-button>
      </div>
    </el-dialog>
    
     <el-dialog title="编辑获客单价" :visible.sync="editAtvDialog">
     	 <el-form :model="chooseAtv">
     	 	 <el-radio v-model="chooseAtv.type" :label="idx+1" v-for="it,idx  in config" :key="idx">{{it}}</el-radio>
     	 	 <el-input placeholder="输入获客单价" v-model="chooseAtv.atv" class="w220"></el-input>
     	 </el-form>
     	 <div slot="footer" class="dialog-footer">
        <el-button @click="editAtvDialog = false">取 消</el-button>
        <el-button type="primary" @click.native="postAtv">确 定</el-button>
      </div>
     </el-dialog>

    <el-dialog class="edit-channel-discount-dialog" title="编辑扣量比例（范围0-1）" :visible.sync="editAldChannelDiscountDialog" :close-on-click-modal="false">
      <el-input placeholder="请输入扣量比例" v-model="editAldChannelDiscountValue.pr"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editAldChannelDiscountDialog = false">取 消</el-button>
        <el-button type="primary" @click.native="postAldChannelDiscount">确 定</el-button>
      </div>
    </el-dialog>
    

    
    <el-drawer title="我是标题" size="580px" :visible.sync="drawer" direction="rtl" :with-header="false">
			<el-tabs v-model="FieldIndex" type="card" @tab-click="fieldListChange">
			    <el-tab-pane label="按字段设置" name="0">
			    	<div class="filedFlex">
						<div class="fliedLeft">
							
							
							<div class="des">
								<span>可选字段</span><el-button type="success" @click="saveSelectField">确认并保存</el-button>
							</div>
							<div class="fliedBtns" v-for="(value,key) in fieldList">
								<div class="key">{{key}}</div>
								<div class="btnsbox">
		
									<el-button :type="item.isCheck?'primary':''" :plain="item.isCheck?false:true" size="mini" v-for="(item,index) in value" @click.native="fliedTap(key,index)" :autofocus="false">{{item.name}}</el-button>
		
								</div>
		
							</div>
							<div class="fliedFt">
								<el-button type="success" @click="saveSelectField">确认并保存</el-button>
							</div>
						</div>
						<div class="fliedRight">
							<div class="tit">已选字段</div>
							<draggable v-model="selectFieldList" :move="onMove" @start="isDragging=true" @end="isDragging=false">
								<transition-group type="transition" tag="ul">
									<li v-for="item in selectFieldList" :key="item.key" class="item">
										<i class="el-icon-rank"></i> {{item.name}}
										<i class="el-icon-close" @click="removeSelectField(item)"></i>
									</li>
								</transition-group>
							</draggable>
						</div>
					</div>
			    </el-tab-pane>
			    <el-tab-pane label="按模块设置" name="1">
			    	<div class="filedFlex">
						<div class="fliedLeft">
							
							
							<div class="des">
								<span>可选字段</span><el-button type="success" @click="saveSelectField">确认并保存</el-button>
							</div>
							<div class="fliedBtns" v-for="(value,key) in fieldList">
								<div class="key">{{key}}</div>
								<div class="btnsbox">
		
									<el-button :type="item.isCheck?'primary':''" :plain="item.isCheck?false:true" size="mini" v-for="(item,index) in value" @click.native="fliedTapForModel(key,index)" :autofocus="false">{{item.name}}</el-button>
		
								</div>
		
							</div>
							<div class="fliedFt">
								<el-button type="success" @click="saveSelectField">确认并保存</el-button>
							</div>
						</div>
						<div class="fliedRight">
							<div class="tit">已选字段</div>
							
							<div class="fliedModel" v-for="(value, key, index) in selectFieldListForModel" >
								<div class="fliedModelKey">{{key}}</div>
								<draggable v-model="selectFieldListForModel[key]" :move="onMove" @start="isDragging=true" @end="isDragging=false">
									<transition-group type="transition" tag="ul">
										<li v-for="item in value" :key="item.key" class="item">
											<i class="el-icon-rank"></i> {{item.name}}
											<i class="el-icon-close" @click="removeSelectFieldForModel(item,key)"></i>
										</li>
									</transition-group>
								</draggable>
							</div>
							
							
						</div>
					</div>
			    	
			    </el-tab-pane>
			 </el-tabs>
			
		</el-drawer>
		
		
		    <el-dialog :title="batchVal==1?'批量通知下线':'批量截止下线'" :visible.sync="batchDialog" width="1150px" :close-on-click-modal="false">
      <el-form :model="form"   label-width="140px">

				
				<el-upload
				v-if="batchForm.length==0"
			  class="upload-demo"
			  drag
			  :action="url"
				:headers="headers"
				:on-success="batchSuccess"
				name="file"
				:show-file-list="false"
				 >
			  <i class="el-icon-upload"></i>
			  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			  <div class="el-upload__tip" slot="tip">只能上传csv文件</div>
			</el-upload>
      </el-form>
      <el-row :gutter="5" class="yltt" v-if="batchForm.length>0" >
       	<el-col  :span="24">{{batchTips}}</el-col>
       </el-row>
       <el-row :gutter="5" v-for="item,index in batchForm" :key="index" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0">
       		<el-col  :span="12" v-for="(citem,idx) in  item" :key="idx">
       				{{citem}}
       		</el-col>	
       		
       </el-row>
      


      <div slot="footer" class="dialog-footer" v-if="batchForm.length>0">
       
        <el-button type="primary" @click="batchDialog=false" >知道了</el-button>
       
      </div>
    </el-dialog>
    
  </section>
</template>

<script>
import {PostChannelDiscount,AtvEdit,notifyOff, getCFXDataList, getDetailData , getIssuedAppList,getIssuedAldChanneList,getCFXDataListDetail,baseUrl ,importAldChannelData, getIssuedAldCompany, getfieldFilter, postfieldFilter,} from "../../api/api";
import echarts from "echarts";

import draggable from 'vuedraggable'

export default {
	components: {
			draggable
		},
  data() {
  	
    return {
    	detailDialog:false,
      chartColumn: null,
      pdata: {
      	issued_app_id:"",
        page: 1,
        perpage: 20,
        company:"",
        company_id:"",
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 *7* 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        // sdate: "2019-04-15",
        // edate: "2019-04-15",
        status:''
      },
      chooseAtv:{
      	index_id:'',
      	atv:'',
      	type:'',
      },
      chooseDetailAtv:{
      	index_id:'',
      	atv:'',
      	index:'',
      },
      pDetaildata: {
      	issued_app_id:"",
        page: 1,
        perpage: 20,
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 *7* 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-15",
        // edate: "2019-04-15",
      },
      companys: [],
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      editAtvDialog: false,
      editAldChannelDiscountDialog: false,
      editAldChannelDiscountValue: {},
      multipleSelection: [],
      group: {},
			chooseProduct:{name:"",id:''},
			chooseChannel:{name:"",id:""},
			IssAppList:[],
			IssuedAldChanneList:[],
      dateVal: [new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)],
      dateVal2: [new Date(new Date().getTime() - 3600 * 1000 *7 * 24)
          .toISOString()
          .slice(0, 10),new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)],    
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      ddata:{ total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["访问人数", "打开次数", "新用户数","新增授权","单个用户点击次数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
            // "访问人数", "打开次数", "新用户数","新增授权","单个用户点击次数"
          {name: "访问人数",type: "line",smooth: true,data: []},
          {name: "打开次数",type: "line",smooth: true,data: []},
          {name: "新用户数",type: "line",smooth: true,data: []},
          {name: "新增授权",type: "line",smooth: true,data: []},
          {name: "单个用户点击次数",type: "line",smooth: true,data: []},
        ],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      },
//    batchDialog:false,
//    batchForm:[],
//			batchTips:'0',
//			url:baseUrl+"issuedAldChannelData/preview",
//			headers:{
//        'token':this.$cookie.getCookie("login")
//   },
     form: {
     },
		batchDialog:false,
		batchForm:[],
		batchTips:'导入预览',
		batchVal:'',
		url:baseUrl+"/IssuedAldChannel/batchNoticeEnd",
	  headers:{
	      'token':this.$cookie.getCookie("login")
	  },
    drawer: false, //默认不展开
				fieldList: {
					'用户数据': [
					
					{
							"name": "uv",
							"key": "visit_uv",
							"isCheck": false
					},
					{
							"name": "新增uv",
							"key": "visit_uv_new",
							"isCheck": false
					},
					{
							"name": "新增确认点击数",
							"key": "clickok_uv_new",
							"isCheck": false
					},	
					{
							"name": "活跃确认点击数",
							"key": "clickok_uv",
							"isCheck": false
					},		
					],
					'流量主数据': [
						{
							"name": "获客单价",
							"key": "atv",
							"isCheck": false
						},
						{
							"name": "新增分发arpu",
							"key": "new_arpu_ff",
							"isCheck": false
						},
						{
							"name": "新增总arpu",
							"key": "new_arpu",
							"isCheck": false
						},
						{
							"name": "活跃分发arpu",
							"key": "uv_arpu_ff",
							"isCheck": false
						},
						{
							"name": "活跃总arpu",
							"key": "uv_arpu",
							"isCheck": false
						},
						
					],
					'分发数据': [

						{
							"name": "新增占比",
							"key": "new_per",
							"isCheck": false
						},	
						{
							"name": "新增跳出",
							"key": "jump_per",
							"isCheck": false
						},
						
						{
							"name": "活跃跳出",
							"key": "uv_jump_per",
							"isCheck": false
						},
					
															
					],
					'收支数据': [
						{
							"name": "新增回收",
							"key": "new_back_0",
							"isCheck": false
						},
						{
							"name": "最高承受单价",
							"key": "hold_price",
							"isCheck": false
						},
						{
							"name": "活跃回收",
							"key": "uv_back_0",
							"isCheck": false
						},
						{
							"name": "累计回收",
							"key": "total_back_0",
							"isCheck": false
						},		
						
					],
					'操作':[{
							"name": "下线时间",
							"key": "update_time",
							"isCheck": false
						
					}]
				},
				selectFieldList: [],
				selectFieldListForModel:{
				'用户数据':[],
				'流量主数据':[],
				'分发数据':[],
				'收支数据':[],
				'操作':[]
				},
				showFieldList: [],
				FieldIndex:0,
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    },
    dateVal2: {
      handler(n, o) {
        if (n[0]) {
          this.pDetaildata.sdate = n[0];
          this.pDetaildata.edate = n[1];
          this.showDetail('');
        }
      },
      deep: true
    },
    'pdata.company_id': {
    	
      handler(n, o) {
				
          this.pdata.company_id = n;
          this.getList();
       
      },
      deep: true
    }
  },
  methods: {
  	downloadTemp(v){
  		if(v==1){
  			window.location.href='/static/channel_notice_end.csv';

  		}
  		else{
  			window.location.href='/static/channel_end.csv';
  		}
  		
  	},
  	showBatchDialog(v){
  		this.batchDialog = true;
  		this.batchTips='';
  		this.batchForm=[];
  		this.batchVal = v;
  		if(v==1){
  			this.url=baseUrl+"/IssuedAldChannel/batchNoticeEnd";
  		}
  		else if(v==2){
  			this.url=baseUrl+"/IssuedAldChannel/batchEnd";
  		}
  	},
  	batchSuccess(response, file, fileList){
			debugger
  		if(response.code==200){
  			this.batchForm=response.data;
  			if(this.batchForm.length==0){
  				this.batchDialog = false;
  				 this.$message({ message: "批量操作成功！", type: "success" });
  			}
  			else{
  				this.batchTips='以下渠道未操作成功';
  			}
  			this.getList();
  		}
  		
  		
  	},
  	atvDetailEdit(scope){
 
  		console.log(scope.$index);
  		this.chooseDetailAtv.index = scope.$index;
  		this.chooseDetailAtv.index_id = scope.row.index_id;
  		this.chooseDetailAtv.atv = scope.row.atv;
  		this.ddata.list.map((v,i)=>{
  			v.isEdit = false;
  		})
  		this.ddata.list[scope.$index].isEdit = true;
  		
  	},
  	fieldListChange(tab, event){
				var _this = this;
				console.log(tab.name);
				this.FieldIndex =tab.name;
				this.setFieldList()
			},
			setFieldList(){
				var _this = this;
				for(var key in _this.fieldList){
						_this.fieldList[key].forEach((v, i) => {
							v.isCheck = false;
						})
				}
				if(this.FieldIndex==0){
						this.selectFieldList.forEach((vv, ii) => {
							for(var key in _this.fieldList) {
								_this.fieldList[key].forEach((v, i) => {
									if(vv.key == v.key) {
										v.isCheck = true;
									}
								})
							}
						});
						this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					}
					else if(this.FieldIndex==1){
						for(var key in this.selectFieldListForModel){
					
							this.selectFieldListForModel[key].forEach((vv,ii)=>{
								_this.fieldList[key].forEach((v, i) => {
										
									if(vv.key == v.key) {
				
										v.isCheck = true;
									}
								})
							})
						}
						var tempArr=[];
						for(var key in this.selectFieldListForModel){
							this.selectFieldListForModel[key].forEach((v,i)=>{
								tempArr.push(v)
							})
							
						}
						this.showFieldList = JSON.parse(JSON.stringify(tempArr));
					}
					this.getList();
			},
			async getSelectField() {
				var _this = this;
				var p = "position=issuedAldData";
				const data = await getValidProductPlatform(p, this.$cookie.getCookie("login"))
				if(data.code == 200) {
					if(!this.$cookie.getCookie("platform_id")){
						this.pdata.platform_id = data.data[0].platform_id;
					}
					
					this.get_issued_app_platform = data.data;
				}

				this.getField();
			},
			getField() {
				console.log(this.pdata.platform_id)
				var _this = this;
				var p = "position=issuedAldData";
				getfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					
					this.FieldIndex = res.data.content.FieldIndex;
					
					console.log(res.data.content);
					if(res.data.content.FieldList == null || res.data.content.FieldList.length == 0) {
		

						res.data.content.FieldList = ['visit_uv_new','visit_uv','atv','new_per','jump_per','back_0','uv_jump_per','uv_back_0','total_back_0','update_time'];
					
					}
					
					
					_this.selectFieldList = [];
					_this.selectFieldListForModel =  {
								'用户数据':[],
								'流量主数据':[],
								'分发数据':[],
								'收支数据':[],
								'操作':[]
								};
					_this.showFieldList = [];
					_this.list = [];
//					for(var key in _this.fieldList){
//						_this.fieldList[key].forEach((v, i) => {
//								v.isCheck = false;
//						})
//					}
					
					res.data.content.FieldList.forEach((vv, ii) => {
						for(var key in _this.fieldList) {
							_this.fieldList[key].forEach((v, i) => {
								if(vv == v.key) {
									v.isCheck = true;
									_this.selectFieldList.push(v);
								}
							})
						}
					});
					for(var key in res.data.content.FieldListForModel){
						res.data.content.FieldListForModel[key].forEach((vv,ii)=>{
							_this.fieldList[key].forEach((v, i) => {
								
								if(vv == v.key) {
									v.isCheck = true;
									_this.selectFieldListForModel[key].push(v);
								}
							})
						})
					}
					
					if(this.FieldIndex==0){
						this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					}
					else if(this.FieldIndex==1){
						var tempArr=[];
						for(var key in this.selectFieldListForModel){
					
							this.selectFieldListForModel[key].forEach((v,i)=>{
								tempArr.push(v)
							})
							
						}
						this.showFieldList = JSON.parse(JSON.stringify(tempArr));
					}
					this.getList();
				})
			},
			saveSelectField() {
				var tempArr = [];
				var tempArrModel={
					'用户数据':[],
					'流量主数据':[],
					'分发数据':[],
					'收支数据':[],
					'操作':[]
				};
				this.selectFieldList.forEach((v, i) => {
					tempArr.push(v.key);
				})
			
				for(var key in this.selectFieldListForModel){
						
					this.selectFieldListForModel[key].forEach((v,i)=>{
						tempArrModel[key].push(v.key)
					})
				}
				var content = {
					FieldIndex: this.FieldIndex,
					FieldList:tempArr,
					FieldListForModel:tempArrModel,
				}
				
				var p = {
					position: 'issuedAldData',
					content: content,
				}
				postfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					this.drawer = false;
					this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					this.getField();

				})
			},
			removeSelectField(obj) {
				this.removeArrForObjName(this.selectFieldList, obj);

				for(let key in this.fieldList) {
					this.fieldList[key].some((item, index) => {
						if(item.name == obj.name) {
		
							this.fieldList[key][index].isCheck = false;

						}
					})
				}

			},
			removeSelectFieldForModel(obj,key){
		
				var _this =this;
				this.removeArrForArrObjName(this.selectFieldListForModel, obj,key);
				
				
				this.fieldList[key].some((item, index) => {
					if(item.name == obj.name) {
	
						this.fieldList[key][index].isCheck = false;

					}
				})
				

				
			},
  	onMove({
				relatedContext,
				draggedContext
			}) {
				const relatedElement = relatedContext.item;
				const draggedElement = draggedContext.item;
			},
			fieldConfig() {
				this.drawer = true;
				this.setFieldList();
				
			},
			fliedTap(key, index) {

				this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
				var result = this.selectFieldList.some(item => {
					if(item.name == this.fieldList[key][index].name) {
						return true
					}
				})
				if(this.fieldList[key][index].isCheck) {
					if(!result) {
						this.selectFieldList.push(this.fieldList[key][index])
					}
				} else {
					if(result) {
						this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index])
					}
				}
			},
			fliedTapForModel(key, index) {
				
				this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
				var result
				for(var key2 in this.selectFieldListForModel){
					result = this.selectFieldListForModel[key2].some(item => {
						if(item.name == this.fieldList[key][index].name) {
							
							return true;
							

						}
					})
					if(result){
						break;
					}
					
				}
	
				if(this.fieldList[key][index].isCheck) {
					if(!result) {
						this.selectFieldListForModel[key].push(this.fieldList[key][index])
					}
				} else {
					if(result) {
				
						this.removeArrForArrObjName(this.selectFieldListForModel, this.fieldList[key][index],key)
					}
				}
			},
			removeArrForObjName(_arr, _obj) {
				var length = _arr.length;
				for(var i = 0; i < length; i++) {
					if(_arr[i].name == _obj.name) {
						_arr.splice(i, 1); //删除下标为i的元素
						return _arr;
					}
				}
			},
			removeArrForArrObjName(obj,_obj,key,){
				console.log(obj)
				var length = obj[key].length;
				for(var i = 0; i < length; i++) {
					if(obj[key][i].name == _obj.name) {
						obj[key].splice(i, 1); //删除下标为i的元素
						console.log(obj)
						return obj;
					}
				}
				
				
				
			},
  	getCompany(){
    	var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
    	getIssuedAldCompany(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          if(res.data&&res.data.length>0){
	            this.companys=res.data;
          }
          else{
          		this.companys=[];
          }
        }
     });
    },
    selectionDisabled(row,index){
      if(row.pr=='-'){
        return false;
      }else{
        return true;
      }
    },
    handleSelection(val){
      this.multipleSelection = val;
    },
    editAldChannelDiscount(row,type){
//      console.log(row);
      if(row.pr=='-'){
        this.$message({ message: "扣量策略中没有该渠道！", type: "warning" });
        return;
      }
      if(type==1){//单个渠道设置扣量比例
        this.editAldChannelDiscountValue={
          issued_app_id:row.issued_app_id,
          channel:row.ald_channel,
          pr:row.pr
        }
      }else if(type==2){//多个渠道设置扣量比例
        if(row.length<=0){
          this.$message({ message: "请选择要批量扣量的行！", type: "warning" });
          return;
        }
        this.editAldChannelDiscountValue={
          issued_app_id:row[0].issued_app_id,
          channel:(row.map((item)=>item.ald_channel)).join(','),
          pr:row.pr
        }
      }
      this.editAldChannelDiscountDialog=true;
//      this.$forceUpdate();
    },
    postAldChannelDiscount(){
      if(isNaN(this.editAldChannelDiscountValue.pr) || this.editAldChannelDiscountValue.pr>1 || this.editAldChannelDiscountValue.pr<0){
        this.$message({ message: "非法输入值！", type: "warning" });
        return;
      }
      var p = this.editAldChannelDiscountValue;
      PostChannelDiscount(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.editAldChannelDiscountDialog=false;
          this.$message({ message: "修改成功", type: "success" });
          this.getList();
        }
        else{
          this.$message.error('修改失败');
        }
      });
    },
  	editAtv(row){
  	 	  this.editAtvDialog=true;
  	 	  this.chooseAtv={
  	 			index_id:row.index_id,
  	 			atv:row.atv,
  	 			type:1,
  	 		}
  	 	  switch(row.type){
  	 	  	case '阿拉丁' : this.chooseAtv.type=1;
  	 	  	break;
  	 	  	case '微信' : this.chooseAtv.type=2;
  	 	  	break;
  	 	  	case '广点通' : this.chooseAtv.type=3;
  	 	  	break;
  	 	  	case '内部矩阵' : this.chooseAtv.type=4;
  	 	  	break;

  	 	  }  
  	 	  this.$forceUpdate();
  	 },
  	 postAtv(type){
  	 	if(type=='detail'){
  	 		var p = this.chooseDetailAtv;
  	 	}
  	 	else{
  	 			var p = this.chooseAtv;
  	 	}
  	 	AtvEdit(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	 this.editAtvDialog=false;
        	  this.$message({ message: "修改成功", type: "success" });
        	  if(type=='detail'){
        	  	this.ddata.list[this.chooseDetailAtv.index].atv = this.chooseDetailAtv.atv;
        	  	this.ddata.list[this.chooseDetailAtv.index].isEdit = false;
        	  	
        	  }
        	  else{
        	   // "访问人数", "打开次数", "新用户数","新增授权","单个用户点击次数"
           	 this.getList();
        	  }
 
        }
        else{
        	this.$message.error('修改失败');
        }
      });
  	 },

  	 tableRowClassName({row, rowIndex}) {
        if (row.status!=1) {
          return 'warning-row';
        } 
        return '';
     },
  	selectDate(e){
  		this.pdata.sdate = e;
      this.pdata.edate = e;
      this.getList();
      
  		
  	},
    notifyOff(index,row,status){
    	var tip;
			if(status==0){
				tip='通知下线'
			}
			else if(status == 1){
				tip = '取消通知下线'
			}
			else if(status == 2){
				tip = '截止下线'
			}
      this.$confirm('确定'+tip+'吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {

        notifyOff({"channel_id":row.channel_id, "status":status}, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.$message({ message: tip+'成功！', type: "success" });
            //this.cdata.list[index].status="0";
            this.getList();
          }
          else{
            this.$message.error('操作失败');
          }
        });

      }).catch(() => {
      });

    },
  	showDetail(s){
  	this.detailDialog=true;
  	if(s){
  		this.pDetaildata.channel_id=s.channel_id
  		this.pDetaildata.issued_app_id=s.issued_app_id;

  	}
  	var p = "";
      for (var k in this.pDetaildata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pDetaildata[k]) p += k + "=" + this.pDetaildata[k] + "&";
      }
      getCFXDataListDetail(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
            // "访问人数", "打开次数", "新用户数","新增授权","单个用户点击次数"
             if(res.data.list&&res.data.list.length>0){
             	res.data.list.map((v,i)=>{v.isEdit=false})
		             this.ddata.list = res.data.list;
	          }
             else{
             	this.ddata.list=[];
             }

         
        }
      });
//		  @click="$router.push({
//	          name:'渠道数据分析列表详情',
//	          params:{issued_app_id:scope.row.issued_app_id,channel_id:scope.row.channel_id},query:{sdate:pdata.sdate,edate:pdata.edate}
//	        })"
  	},
  	goback(){
  		this.$router.back(-1)
  	},
    changeProduct(res){
     this.$cookie.setCookie("issued_app_id",res.id);
		 this.$route.params.issued_app_id=res.id;
	 	 this.pdata.issued_app_id=res.id;
	 	 this.getList();
	 	 this.getIssuedChanneList();
	 	 
	 },
	 changeChannel(res){

	 	this.pdata.kw=res.ald_channel;
	 	this.getList();
	 },
	 clearChannel(res){
	 		this.pdata.kw=this.chooseChannel.name;
	 		this.getList();
	 },
	 getIssAPPList(){
		var p="";
		getIssuedAppList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.IssAppList = res.data;
          this.IssAppList.forEach((v,i)=>{
          	if(v.id==this.pdata.issued_app_id ){
          		this.chooseProduct.name=v.name;
          	}
          })
        }
      });
	},
	getIssuedChanneList(){
		var p="issued_app_id="+this.pdata.issued_app_id;
		getIssuedAldChanneList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.IssuedAldChanneList = res.data.list;
          
        }
      });
	},
	getConfig() {
	     if (this.$store.config) {
	       this.config = this.$store.config.get_channel_price_type;
	     } else {
	       setTimeout(() => {
	         this.getConfig();
	       }, 50);
	     }
	   },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getCFXDataList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
            // "访问人数", "打开次数", "新用户数","新增授权","单个用户点击次数"
            
           this.cdata.list = res.data.list;
           this.cdata.total = res.data.total;
           this.maxPage = res.data.max_page;
          
//        this.option.xAxis.data = res.data.chart.date;
//        this.option.series[0].data = res.data.chart.visit_uv;
//        this.option.series[1].data = res.data.chart.session_cnt;
//        this.option.series[2].data = res.data.chart.visit_uv_new;
//        this.option.series[3].data = res.data.chart.auth_uv_new;
//        this.option.series[4].data = res.data.chart.click_per;
//        this.drawColumnChart();
        }
      });
    },
   
    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    statusChange(v) {
      this.pdata.status = v;
      this.cdata.list=[];
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10),
                      new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10)]
      // this.getList();
    },
//  downloadTemp(){
//		window.location.href='/static/channel_data_import.csv';
//	},
//  batchSuccess(response, file, fileList){
//
//		if(response.code==200){
//			this.batchForm=response.data;
//		}
//		
//		
//	},
     //批量增加
//	batchAddProduct(){
//		this.batchDialog=true;
//	},
//	batchCalcel(){
//  	this.batchDialog = false;
//  	this.batchForm=[];
//  	this.batchTips="0"
//  },
//  deleteBatch(index){
//  	 this.batchForm.splice(index,1);
//  },
//  batchSubmit(){
//  	
// 		var p ={
//	  		"overwrite":this.batchTips,
//				"data":JSON.parse(JSON.stringify(this.batchForm)),
//    };
//    p.data.forEach((v,i)=>{
//    	
//    	if(v.length>6){
//    		v.pop()
//    	}
//    })
//    importAldChannelData(p, this.$cookie.getCookie("login")).then(response => {
//    	debugger;
//      if (response.data.code == 200) {
//      	
//       	 if(response.data.data.length>0){
//       	 	 
//      			this.batchForm=response.data.data;
//      			this.batchForm.unshift(["日期","发行游戏","渠道名称","新增用户","活跃用户","单价"]);
//      			this.batchTips="1";
//      			
//      			
//       	 }
//       	 else{
//       	 	 this.$message({ message: "导入成功", type: "success" });
//       	 	 this.batchDialog = false;
//       	 	 this.batchForm=[];
//       	 	 this.batchTips="0";
//       	 	 this.getList();
//       	 }
//      }
//      else{
//      	this.$message.error('导入失败');
//      	 
//      }
//   });
//  },
  },
  mounted() {

  	this.pdata.issued_app_id=this.$route.params.issued_app_id;
  	if(this.$route.query.sdate!=undefined){
  		this.pdata.sdate=this.$route.query.sdate;
  	}
  	if(this.$route.query.edate!=undefined){
  		  	this.pdata.edate=this.$route.query.edate;
  	}
  	this.dateVal = [this.pdata.sdate,this.pdata.edate];
  	//this.dateVal2 = [this.pdata.sdate,this.pdata.edate];
  	this.getIssAPPList();
  	this.getIssuedChanneList();
  	this.getConfig();
  	this.getCompany();
    this.getField();
    document.getElementById('yesterday').focus();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}


  .el-table .warning-row td{
  	 background: oldlace !important;
  	 color: #cccccc;
  }
  .edit-channel-discount-dialog .el-dialog{
    width: 400px !important;
  }
  .edit-channel-discount-dialog .el-input{
    width: 360px !important;
  }

</style>

<style scoped="scoped" type="text/css">
  .blue{
		color: #0082E6;
  }
  .orange{
  	color:orange;
  }
</style>


<style scoped="scoped" lang="scss">
	.totalBox{
		background:#f5f5f5;
	}
	.tc{
		text-align: center;
	}
	.red {
		color: #FF0000;
	}
	
	.green{
		color: #11B95C;
	}
	.lh45{
		line-height: 45px;
	}
	.h45{
		height: 45px;
	}
	
	.filedFlex {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		height: 100%;
	}
	
	.fliedLeft {
		width: 360px;
		border-right: 1px solid #E6E6E6;
		box-sizing: border-box;
		height: 100%;
		height:calc(100vh - 70px);
		overflow-y: auto;
	}
	
	.fliedRight {
		width: 220px;
		height: 100%;
		height: 100vh;
		overflow-y: auto;
	}
	
	.tit {
		padding: 0 10px;
		text-align: left;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		border-bottom: 1px solid #E6E6E6;
	}
	
	.filedFlex .des {
		padding: 0 15px;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
		margin: 10px 0;
		span{
			
		}
		button{
			float: right;
		}
	}
	
	.filedFlex .key {
		padding: 0 15px;
		font-size: 14px;
		height: 50px;
		line-height: 50px;
		font-weight: bold;
	}
	
	.btnsbox {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
		padding: 5px;
	}
	
	.btnsbox button {
		margin: 5px;
	}
	
	.btnsbox button:focus {}
	
	.fliedRight ul {
		margin: 0;
		padding: 0;
	}
	
	.fliedRight ul li {
		line-height: 40px;
		list-style: none;
		border-bottom: 1px solid #E6E6E6;
		padding: 0 10px;
	}
	
	.fliedRight ul li i {
		margin-right: 5px;
	}
	
	.fliedRight ul li i.el-icon-close {
		float: right;
		cursor: pointer;
		margin-top: 15px;
	}
	
	.fliedFt {
		margin: 20px 0;
		padding: 0 10px;
	}
	.fliedModel{
		border-bottom: 2px solid #20A0FF;
	}
	.fliedModelKey{
		padding: 10px;
		font-size: 18px;
		font-weight:bold ;
	}
</style>








// WEBPACK FOOTER //
// channelDataList.vue?1b83a362